import "../styles/AppCards.css";

function AppCards() {
  return (
    <div className="App__header">
      <div className="App__card">
        <h5>
          Double-click on text in any row to edit it. New rows can't be created
          if editing is in progress and vice versa.{" "}
        </h5>
      </div>
      <div className="App__card">
        <h5>
          These rows can be nested. If you move or delete a parent row, its
          children will also be affected (moved/deleted).
        </h5>
      </div>
      <div className="App__card">
        <h5>
          Drag and drop any row by holding the mouse button over it. The list
          will reset upon tab refresh
        </h5>
      </div>
    </div>
  );
}

export default AppCards;
